import { connect } from "react-redux"
import View from "./view"
import { shouldScrollToBottom } from "modules/Buyer/Questions/actions"

const mapDispatchToProps = {
  shouldScrollToBottom,
}

export default connect(null, mapDispatchToProps)(View)
